import {AppError} from "./AppError";
import {startLoadind, stopLoadind} from "./loadingEngine";

type HttpThenCallback<T = any> = (msg: T) => void
type HttpErrorCallback = (msg: AppError<any>) => void

export class HttpRequest<T> {
    r: XMLHttpRequest = new XMLHttpRequest();
    oks: HttpThenCallback<T>[] = [];
    catches: HttpErrorCallback[] = [];

    processOk() {
        try {
            const result = JSON.parse(this.r.responseText)
            for (let ok of this.oks) {
                ok(result);
            }
        } catch (e) {
            this.processError<any>({
                message: "json parse error",
                status: 666,
                data: e
            });
        }
        stopLoadind()
    }

    preprocessError() {
        try {
            const resp = JSON.parse(this.r.responseText);
            const err: AppError<any> = {
                status: this.r.status,
                message: resp.message,
                data: resp.data
            };
            for (let c of this.catches) {
                c(err);
            }
            if (err.status === 403) {
                // S.throw(err);
            }
        } catch (e) {
            this.processError<any>({
                message: "json parse error",
                status: 666,
                data: e
            });
        }
        stopLoadind()
    }

    processError<E>(err: AppError<E>) {
        for (let c of this.catches) {
            c(err);
        }
    }

    doneCB: any = null
    done(cb: () => void) {
        this.doneCB = cb;
    }

    constructor() {
        this.r.withCredentials = false;
        this.r.onreadystatechange = () => {
            if (this.r.readyState !== 4) return;
            if (this.r.status === 200) {
                this.processOk()
            } else if (this.r.status) {
                this.preprocessError();
            }
            if (this.doneCB) this.doneCB()
        }
    }


    ok(callback: HttpThenCallback<T>) {
        this.oks.push(callback);
        return this;
    }

    error(callback: HttpErrorCallback) {
        this.catches.push(callback);
        return this;
    }
    cancel() {
        this.processError<any>({
            message: "canceled",
            status: 999,
            data: {}
        });
        stopLoadind();
        this.r.abort();

    }
}

function fillHeaders(req: HttpRequest<any>, headers: any) {
    for (let h in headers) {
        req.r.setRequestHeader(h, headers[h]);
    }
}

class Http {
    bearer = "";
    baseUrl = "";
    headers: any = {};

    setHeader(name: string, val: string) {
        this.headers[name] = val;
    }

    n(): string {
        let r = Math.floor(Math.random()*200000);
        return r.toString();
    }

    reqQueue: any = {};
    reqPanding: any = [];
    planeSend<T>(req: HttpRequest<T>, data: any): HttpRequest<T> {
        let ok = false;
        for (let i = 0; i < 10; i++) {
            if (!this.reqQueue[i]) {
                ok = true;
                this.reqQueue[i] = () => {
                    req.done(() => {
                        this.reqQueue[i] = undefined;
                        if (this.reqPanding.length) {
                            req = this.reqPanding.shift();
                            this.planeSend(req, data);
                        }
                    });
                    if (data) {
                        req.r.send(data);
                    } else {
                        req.r.send();
                    }
                }
                this.reqQueue[i]();
            }
        }
        if (!ok) this.reqPanding.push(req);
        return req;
    }

    get<T>(url: string) {
        const req = new HttpRequest<T>();
        let realUrl = this.baseUrl.replace("{{random}}", this.n()) + url;
        if (url.startsWith("http://") || url.startsWith("https://")) realUrl = url

        req.r.open("GET", realUrl, true);
        req.r.setRequestHeader("Authorization", "Bearer " + this.bearer);
        fillHeaders(req, this.headers);
        startLoadind()
        // this.planeSend(req, null);
        req.r.send()
        return req;
    }

    post<T>(url: string, data: any) {
        const req = new HttpRequest<T>();
        let realUrl = this.baseUrl.replace("{{random}}", this.n()) + url;
        if (url.startsWith("http://") || url.startsWith("https://")) realUrl = url
        req.r.open("POST", realUrl, true);

        req.r.setRequestHeader("Content-Type", "application/json");
        req.r.setRequestHeader("Authorization", "Bearer " + this.bearer);
        fillHeaders(req, this.headers);
        startLoadind()
        // this.planeSend(req, JSON.stringify(data));
        req.r.send(JSON.stringify(data));
        return req;
    }

    delete<T>(url: string) {
        const req = new HttpRequest<T>();
        let realUrl = this.baseUrl.replace("{{random}}", this.n()) + url;
        if (url.startsWith("http://") || url.startsWith("https://")) realUrl = url

        req.r.open("DELETE", realUrl, true);
        req.r.setRequestHeader("Authorization", "Bearer " + this.bearer);
        fillHeaders(req, this.headers);
        startLoadind()
        // this.planeSend(req, null);
        req.r.send()
        return req;
    }
}

const http = new Http();
export default http;
